export const ROUTE = {
  CREATE_PLUGIN: '/create',
  EDIT_PLUGIN: '/:id/edit',
};

export default ROUTE;
